import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Vegetables.css";

const vegetableProducts = [
    {
        id: 1,
        name: "EGYPTIAN GARLIC",
        image: "/assets/img/Vegetables/garlic.png",
        usage: [
            {
                title: "Product Details",
                points: [
                    "Origin: Egypt",
                    "Strong spiciness, milky-white flesh, firm texture, and naturally bright color",
                    "Clean roots with no burnt, moldy, or dirty skins",
                    "Free from mechanical damage",
                ],
            },
            {
                title: "Season & Availability",
                points: [
                    "Season: January to April",
                    "Container Type: 40-foot reefer container",
                    "Available Bulb Size: 4 cm to 7 cm",
                    "Container Capacity: 25 metric tons, subject to customer packaging requirements",
                ],
            },
        ],
    },
    {
        id: 2,
        name: "RED ONIONS",
        image: "/assets/img/Vegetables/onion.png",
        usage: [
            {
                title: "Product Details",
                points: [
                    "Red onions, also known as purple onions",
                    "Purplish-red skin with white flesh tinged with red",
                    "Medium to large size with a mild to sweet flavor",
                ],
            },
            {
                title: "Season & Availability",
                points: [
                    "Season: May to December",
                    "Container Type: 40-foot reefer container",
                    "Available Counts: 40–60, 50–70, 60–80, 70–90, 80–100, 90–110",
                    "Container Capacity: 1,100 mesh bags of 25 kg each, subject to customer packaging requirements",
                ],
            },
        ],
    },
    {
        id: 3,
        name: "SWEET POTATO",
        image: "/assets/img/Vegetables/sweet-potato.png",
        usage: [
            {
                title: "Product Details",
                points: [
                    "Botanical Name: Ipomoea batatas",
                    "A starchy, tuberous crop from a perennial dicotyledonous plant",
                    "Belongs to the Convolvulaceae (morning glory) family",
                ],
            },
            {
                title: "Season & Availability",
                points: [
                    "Season: August to March",
                    "Container Type: 40-foot reefer container",
                    "Available Sizes: 300 g to 600 g",
                    "Container Capacity: 25 metric tons, subject to customer packaging requirements",
                ],
            },
        ],
    },
];

const defaultImage = "/assets/img/Vegetables/vegetables-placeholder.jpg";

export default function Vegetables() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const closeModal = () => setSelectedProduct(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!selectedProduct) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") closeModal();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [selectedProduct]);

    return (
        <>
            <Breadcrumb
                title="Vegetables"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="vegetables-section">
                <div className="container">
                    <h1 className="vegetables-title">Fresh Vegetables Collection</h1>
                    <p className="vegetables-subtitle">
                        A selection of fresh vegetables for retail, wholesale, and food-service
                        requirements.
                    </p>

                    <div className="vegetables-grid">
                        {vegetableProducts.map((product, index) => (
                            <div
                                className="vegetables-card"
                                key={product.id}
                                style={{ animationDelay: `${index * 0.06}s` }}
                            >
                                <div className="vegetables-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        loading="lazy"
                                        onError={(event) => {
                                            if (event.currentTarget.src.endsWith(defaultImage)) return;
                                            event.currentTarget.onerror = null;
                                            event.currentTarget.src = defaultImage;
                                        }}
                                    />
                                </div>

                                <div className="vegetables-info">
                                    <h2 className="vegetables-name">{product.name}</h2>
                                    <button
                                        type="button"
                                        className="vegetables-view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div className="vegetables-modal-overlay" onClick={closeModal}>
                            <div
                                className="vegetables-modal-content"
                                role="dialog"
                                aria-modal="true"
                                aria-labelledby="vegetables-modal-title"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="vegetables-modal-image"
                                    onError={(event) => {
                                        if (event.currentTarget.src.endsWith(defaultImage)) return;
                                        event.currentTarget.onerror = null;
                                        event.currentTarget.src = defaultImage;
                                    }}
                                />

                                <h2 id="vegetables-modal-title" className="vegetables-modal-title">
                                    {selectedProduct.name}
                                </h2>

                                <div className="vegetables-usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="vegetables-usage-block">
                                            <h3>{section.title}</h3>
                                            <ul>
                                                {section.points.map((point, pointIndex) => (
                                                    <li key={pointIndex}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    type="button"
                                    className="vegetables-close-btn"
                                    onClick={closeModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}